import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { ILeanEmployeeCheck } from "../getEmployeeChecks/getEmployeeChecks.jsonschema";
import { TQueryEmployeeChecks } from "./queryEmployeeChecksSchema";

export interface IQueryEmployeeChecksData {
  readonly checks: ILeanEmployeeCheck[];
  readonly nextStartAt?: string;
  readonly total?: number;
}

export const queryEmployeeChecks = (axios: IAxiosInstance) => {
  return async (query?: TQueryEmployeeChecks) => {
    const response = await axios.noRetry.get<
      IApiResponse<IQueryEmployeeChecksData>
    >("/api/queryEmployeeChecks", {
      params: { ...query },
      withCredentials: true,
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Something went wrong");
  };
};
